"use client";

import { useSyncExternalStore } from "react";
import { getBaseUrl } from "@/lib/metadata";

const noop = () => () => {};

/**
 * The site's origin for snippets: the real one in the browser (a preview's
 * own URL on a preview), the configured site URL during the server render.
 */
export function useOrigin(): string {
  return useSyncExternalStore(
    noop,
    () => window.location.origin,
    () => getBaseUrl(),
  );
}
